export const CUSTOMER_PRIORITY_LIST_REQUEST = "@CUSTOMER_PRIORITY_LIST_REQUEST";
export const CUSTOMER_PRIORITY_LIST_SUCCESS = "@CUSTOMER_PRIORITY_LIST_SUCCESS";
export const CUSTOMER_PRIORITY_LIST_FAILED = "@CUSTOMER_PRIORITY_LIST_FAILED";

export const CUSTOMER_PRIORITY_IMPORT_REQUEST = "@CUSTOMER_PRIORITY_IMPORT_REQUEST";
export const CUSTOMER_PRIORITY_IMPORT_SUCCESS = "@CUSTOMER_PRIORITY_IMPORT_SUCCESS";
export const CUSTOMER_PRIORITY_IMPORT_FAILED = "@CUSTOMER_PRIORITY_IMPORT_FAILED";

export const CUSTOMER_PRIORITY_REMOVE_REQUEST = "@CUSTOMER_PRIORITY_REMOVE_REQUEST";
export const CUSTOMER_PRIORITY_REMOVE_SUCCESS = "@CUSTOMER_PRIORITY_REMOVE_SUCCESS";
export const CUSTOMER_PRIORITY_REMOVE_FAILED = "@CUSTOMER_PRIORITY_REMOVE_FAILED";

export const CUSTOMER_PRIORITY_STATE_CHANGE = "@CUSTOMER_PRIORITY_STATE_CHANGE";
